import { INotificationType } from './INotificationType';

export enum ISystem {
    SmartCargas = 0,
    SulaHub = 1,
}

export interface INotificationsResponse {
    id: string;
    title: string;
    description: string;
    details: ISulaHubNotificationDetails | ISmartCargasNotificationDetails;
    initialDate: Date;
    finalDate: Date;
    isRead: boolean;
    system: ISystem;
}

export interface INotificationDetails {
    type: INotificationType;
}

export interface ISulaHubNotificationDetails extends INotificationDetails {
    userRequestId: string;
}

export interface ISmartCargasNotificationDetails extends INotificationDetails {
    loadId: string;
    carrierId: string;
    dailyLoadOfferId: string;
    shipmentNumber: string;
}
